<script lang="ts" setup>
// @ts-ignore
import DOMPurify from "dompurify";
import { storeToRefs } from "pinia";

const documentId = inject("documentId") as any;
const documentStore = useSubmittedDocumentStore(documentId);
const { revision, showGeneralCommentForm } = storeToRefs(documentStore);

const nuxtApp = useNuxtApp();

const html = computed((): string[] => {
  // @ts-ignore
  return nuxtApp.$convertQuillDeltaToHTML(revision.value?.commentObject);
});

const appUserData = useAppUserDataStore();
const { commentColor } = storeToRefs(appUserData);

const onShowForm = () => {
  showGeneralCommentForm.value = true;
};
</script>

<template>
  <div
    @click="onShowForm"
    class="hover:bg-light-default cursor-pointer selection:bg-none flex flex-col leading-6"
    :style="{
      color: useArrayToRGB(commentColor),
    }"
    v-if="revision?.commentObject"
  >
    <span v-html="DOMPurify.sanitize(html)"></span>
  </div>
</template>

<style scoped></style>
